import FeaturedIn from './FeaturedIn';

export default FeaturedIn;
